import React, { useState, useEffect } from 'react';
import { ref, onValue, update, get } from "firebase/database";
import { db } from "../firebase";
import Swal from 'sweetalert2';
import { Headset, Lock, User, Save } from 'lucide-react';
import './AdminSettings.css';

const AdminSettings = () => {
  const [links, setLinks] = useState({
    whatsapp: '',
    telegram: ''
  });

  const [adminAuth, setAdminAuth] = useState({
    username: '',
    password: ''
  });

  const [oldPasswordInput, setOldPasswordInput] = useState('');

  useEffect(() => {
    const configRef = ref(db, 'adminConfig');
    onValue(configRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const getUsername = (link) => link ? link.split('/').pop() : '';
        setLinks({
          whatsapp: getUsername(data.whatsapp),
          telegram: getUsername(data.telegram)
        });
        setAdminAuth({
          username: data.username || 'tradehouse1',
          password: data.password || '123123'
        });
      }
    });
  }, []);

  // Section 1: Save Only Customer Links
  const saveLinks = async (e) => {
    e.preventDefault();
    try {
      const finalWhatsapp = `https://wa.me/${links.whatsapp}`;
      const finalTelegram = `https://t.me/${links.telegram}`;

      await update(ref(db, 'adminConfig'), {
        whatsapp: finalWhatsapp,
        telegram: finalTelegram
      });
      Swal.fire('Success', 'Service links updated!', 'success');
    } catch (error) {
      Swal.fire('Error', 'Failed to update links', 'error');
    }
  };

  // Section 2: Save Only Admin Credentials (Needs Old Password)
  const saveAdminAuth = async (e) => {
    e.preventDefault();
    try {
      const configRef = ref(db, 'adminConfig');
      const snapshot = await get(configRef);
      const dbPassword = snapshot.val()?.password || '123123';

      if (oldPasswordInput !== dbPassword) {
        Swal.fire('Unauthorized', 'Old password galat hai!', 'error');
        return;
      }

      await update(ref(db, 'adminConfig'), {
        username: adminAuth.username,
        password: adminAuth.password
      });

      Swal.fire('Updated', 'Admin credentials changed successfully!', 'success');
      setOldPasswordInput('');
    } catch (error) {
      Swal.fire('Error', 'Update failed!', 'error');
    }
  };

  return (
    <div className="settings-container">
      <h2 className="page-title">Global Settings</h2>
      
      <div className="settings-grid">
        {/* SECTION 1: Customer Service */}
        <form onSubmit={saveLinks} className="settings-card">
          <h3><Headset size={20} /> Customer Service (Usernames)</h3>
          <div className="input-group">
            <label>WhatsApp Number</label>
            <div className="prefix-input">
              <span className="prefix-tag">wa.me/</span>
              <input 
                type="text" 
                value={links.whatsapp}
                onChange={(e) => setLinks({...links, whatsapp: e.target.value})}
                placeholder="92300..."
              />
            </div>
          </div>
          <div className="input-group">
            <label>Telegram Username</label>
            <div className="prefix-input">
              <span className="prefix-tag">t.me/</span>
              <input 
                type="text" 
                value={links.telegram}
                onChange={(e) => setLinks({...links, telegram: e.target.value})}
                placeholder="username"
              />
            </div>
          </div>
          <button type="submit" className="save-btn-small">
            <Save size={16} /> SAVE LINKS
          </button>
        </form>

        {/* SECTION 2: Admin Authentication */}
        <form onSubmit={saveAdminAuth} className="settings-card security-card">
          <h3><Lock size={20} /> Admin Authentication</h3>
          <div className="input-group">
            <label><User size={14} /> Admin Username</label>
            <input 
              type="text" 
              value={adminAuth.username}
              onChange={(e) => setAdminAuth({...adminAuth, username: e.target.value})}
            />
          </div>
          <div className="input-group">
            <label><Lock size={14} /> Current Password</label>
            <input 
              type="password" 
              value={adminAuth.password}
              onChange={(e) => setAdminAuth({...adminAuth, password: e.target.value})}
            />
          </div>
          <div className="divider-line"></div>
          <div className="input-group verify-group">
            <label>ENTER OLD PASSWORD TO VERIFY</label>
            <input 
              type="password" 
              placeholder="Confirm old password"
              value={oldPasswordInput}
              onChange={(e) => setOldPasswordInput(e.target.value)}
              required
              className="verify-input"
            />
          </div>
          <button type="submit" className="save-btn-small auth-btn">
            <Save size={16} /> UPDATE CREDENTIALS
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminSettings;